import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import BaseInput from './BaseInput';
import BaseInputProps from './BaseInputProps';

export interface DateInputProps extends BaseInputProps {
  inputProps?: JSX.IntrinsicElements['input'];
}

export default function DateInput({ inputProps, ...baseProps }: DateInputProps) {
  const { name } = baseProps;
  const { register } = useFormContext();
  const [isFocused, setIsFocused] = useState(false);

  return (
    <BaseInput isFocused={isFocused} {...baseProps}>
      <input
        {...register(name)}
        id={name}
        className="mt-2 text-base p-2 block w-full rounded-md border-0 text-limed-spruce-800 shadow-sm ring-1 ring-inset ring-porcelain-300 placeholder:text-porcelain-400 focus:ring-2 focus:ring-inset focus:ring-bondi-blue-600"
        type="date"
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        {...inputProps}
      />
    </BaseInput>
  );
}
